import Divider from '@mui/material/Divider';
import Hero from '../components/landing/Hero';
import Highlights from '../components/landing/Highlights';
import Pricing from '../components/landing/Pricing';
import FAQ from '../components/landing/FAQ';
import Features from '../components/landing/Features';
import Testimonials from '../components/landing/Testimonials';
import BottomLogo from '../components/landing/BottomLogo';

const Home = () => {
    return (
        <>
            <Hero />
            <div>
                {/*<LogoCollection />*/}
                <Features />
                <Testimonials />
                {/*<Highlights />*/}
                {<Pricing />}
                <FAQ />
                <BottomLogo />
                <Divider />
            </div>
        </>
    )
}

export default Home;